import { gql } from "@apollo/client"

export const SITE_PROFILE_UPDATE_POLICY = gql`mutation UpdateSiteProfilePersonalPolicy($id: ID!, $policy: Int!) {
  updateSiteProfilePersonalPolicy (id: $id, policy: $policy) {
  id,
  personal_data_policy
  }
}`
